import dataReport from '@util/datareport';

// 监听事件名
const events = [
  'mousedown',
  'mouseenter',
  'mouseleave',
  'mousemove',
  'mouseover',
  'mouseup',
  'mousewheel',
  'touchstart',
  'touchmove',
  'touchend',
];

// 触发的事件名
const triggerEvents: any[] = [];

// 事件回调
const eventListener = ({ type }: any) => {
  const _include = !triggerEvents.includes
    ? triggerEvents.includes(type)
    : triggerEvents.toString().indexOf(type) !== -1;

  if (!_include) {
    triggerEvents.push(type);
  }
};

// 周期性上报
const intervalReport = () => {
  const _interval = setInterval(() => {
    if (!triggerEvents.length) {
      return;
    }

    dataReport.reportUserInteractionEvent(triggerEvents.join(','));
    triggerEvents.length = 0;

    // 默认 5 分钟上报
  }, window.__INITIAL_STATE__.userInteractionReportInterval || 5 * 60 * 1000);
  return () => {
    clearInterval(_interval);
  };
};

/**
 * 用户行为上报
 */
export const interactionReport = () => {
  const clearIntervalReport = intervalReport();

  events.forEach((e) => {
    document.addEventListener(e, eventListener);
  });

  window.onbeforeunload = () => {
    clearIntervalReport();
    events.forEach((e: string) => {
      document.removeEventListener(e, eventListener);
    });
  };
};
